/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useCallback } from 'react';
import withQnAPagination from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/pagination';
import Loading from '@catalogo/ui-americanas-mobile-loading';
import SortDesk from '@catalogo/ui-americanas-desktop-qna/src/components/molecules/SelectSort';
import { MakeQuestionsBottom } from '../../atoms';
import { SearchFieldComponent, SelectSort } from '../../molecules';
import { Questions } from '../../organisms';
import { ButtonUI, Wrapper, WrapperLoading, Content, Title, WrapperTitle, WrapperBottom, ButtonUIDesk } from './styled';
import { IRenderFetchMoreButton, IQuestionsAndAnswersList } from '../../../types';
import { productResultMessage } from '../../../helpers';

const renderFetchMoreButton = (props: IRenderFetchMoreButton) => {
  const { loading, nextOffset, total, onPaginationClick, isDesk } = props;

  if (loading.all) {
    return <></>;
  }

  if (loading.button) {
    return (
      <WrapperLoading>
        <Loading />
      </WrapperLoading>
    );
  }

  if (nextOffset < total && isDesk) {
    return (
      <ButtonUIDesk
        width="100%"
        height="45px"
        title="Ver mais perguntas"
        borderRadius="8px"
        fontSize="16px"
        onClick={() => onPaginationClick(nextOffset)}
      />
    );
  }

  if (nextOffset < total) {
    return (
      <ButtonUI
        width="100%"
        height="45px"
        title="Ver mais perguntas"
        borderRadius="8px"
        fontSize="16px"
        onClick={() => onPaginationClick(nextOffset)}
      />
    );
  }
  return <></>;
};

export const QuestionsAndAnswersList = (props: IQuestionsAndAnswersList) => {
  const {
    questionsAndAnswers,
    productId,
    fetchMore,
    loading,
    onPaginationClick,
    product,
    config,
    dispatchMetrics,
    isDesk,
  } = props;

  const [term, setTerm] = useState('');
  const [messageTermFound, setMessageTermFound] = useState('');
  const [totalQuestions, setTotalQuestion] = useState<number>();
  const { questions, meta } = questionsAndAnswers;
  const { offset, limit, total } = meta;
  const nextOffset = offset + limit;

  useEffect(() => {
    if (!totalQuestions) {
      return setTotalQuestion(total);
    }
  }, [total]);

  useEffect(() => {
    if (loading?.all && term) {
      setMessageTermFound('');
    } else if (!loading?.all && term && total) {
      const str = productResultMessage(total);
      setMessageTermFound(str);
    }
    return () => setMessageTermFound('');
  }, [loading]);

  const onChangeTerm = useCallback(e => setTerm(e.target.value), []);

  const renderButton = renderFetchMoreButton({ loading, nextOffset, total, onPaginationClick, isDesk });

  const productQuestions = `${totalQuestions} pergunta${
    totalQuestions && totalQuestions > 1 ? 's' : ''
  } sobre esse produto`;

  const title = total == 0 ? 'Poxa, nenhum resultado encontrado' : productQuestions;

  const alignCta = nextOffset >= total;

  const cta = nextOffset >= 6 || alignCta;

  const sortSelect = isDesk ? (
    <SortDesk fetchMore={fetchMore} offset={offset} limit={limit} total={total} />
  ) : (
    <SelectSort fetchMore={fetchMore} offset={offset} limit={limit} total={total} />
  );

  return (
    <Wrapper>
      <SearchFieldComponent
        isDesk={isDesk}
        fetchMore={fetchMore}
        onChange={onChangeTerm}
        term={term}
        dispatchMetrics={dispatchMetrics}
      />
      <WrapperTitle isDesk={isDesk}>
        <Title isDesk={isDesk}>{messageTermFound ? messageTermFound : title}</Title>
        {questions.length != 0 && sortSelect}
      </WrapperTitle>
      <Content isDesk={isDesk}>
        <Questions
          isDesk={isDesk}
          productId={productId}
          questions={questions}
          loading={loading.all}
          totalQuestions={totalQuestions as number}
          totalTermFound={total}
          term={term}
          product={product}
          config={config}
          dispatchMetrics={dispatchMetrics}
        />
        <WrapperBottom isDesk={isDesk} alignCta={alignCta}>
          {renderButton}
          {total !== 0 && cta && (
            <MakeQuestionsBottom
              productId={productId}
              isDesk={isDesk}
              product={product}
              config={config}
              dispatchMetrics={dispatchMetrics}
            />
          )}
        </WrapperBottom>
      </Content>
    </Wrapper>
  );
};

export default withQnAPagination(QuestionsAndAnswersList);
